import { render, staticRenderFns } from "./CreateFlag.vue?vue&type=template&id=30539fd4&"
import script from "./CreateFlag.vue?vue&type=script&lang=js&"
export * from "./CreateFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports